// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Messages/Filters.proto (package time_tracking.messages.filters, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { BusinessLocationSearchBy } from "../Enumerations/BusinessLocationSearchBy_pb";
import { file_Enumerations_BusinessLocationSearchBy } from "../Enumerations/BusinessLocationSearchBy_pb";
import type { BusinessLocationSortBy } from "../Enumerations/BusinessLocationSortBy_pb";
import { file_Enumerations_BusinessLocationSortBy } from "../Enumerations/BusinessLocationSortBy_pb";
import type { BusinessSearchBy } from "../Enumerations/BusinessSearchBy_pb";
import { file_Enumerations_BusinessSearchBy } from "../Enumerations/BusinessSearchBy_pb";
import type { BusinessSortBy } from "../Enumerations/BusinessSortBy_pb";
import { file_Enumerations_BusinessSortBy } from "../Enumerations/BusinessSortBy_pb";
import type { DeletedItemSelection } from "../Enumerations/DeletedItemSelection_pb";
import { file_Enumerations_DeletedItemSelection } from "../Enumerations/DeletedItemSelection_pb";
import type { IdentityRoleSearchBy } from "../Enumerations/IdentityRoleSearchBy_pb";
import { file_Enumerations_IdentityRoleSearchBy } from "../Enumerations/IdentityRoleSearchBy_pb";
import type { IdentityRoleSortBy } from "../Enumerations/IdentityRoleSortBy_pb";
import { file_Enumerations_IdentityRoleSortBy } from "../Enumerations/IdentityRoleSortBy_pb";
import type { IdentityUserSearchBy } from "../Enumerations/IdentityUserSearchBy_pb";
import { file_Enumerations_IdentityUserSearchBy } from "../Enumerations/IdentityUserSearchBy_pb";
import type { IdentityUserSortBy } from "../Enumerations/IdentityUserSortBy_pb";
import { file_Enumerations_IdentityUserSortBy } from "../Enumerations/IdentityUserSortBy_pb";
import type { ProjectSearchBy } from "../Enumerations/ProjectSearchBy_pb";
import { file_Enumerations_ProjectSearchBy } from "../Enumerations/ProjectSearchBy_pb";
import type { ProjectSortBy } from "../Enumerations/ProjectSortBy_pb";
import { file_Enumerations_ProjectSortBy } from "../Enumerations/ProjectSortBy_pb";
import type { SearchOperator } from "../Enumerations/SearchOperator_pb";
import { file_Enumerations_SearchOperator } from "../Enumerations/SearchOperator_pb";
import type { SearchType } from "../Enumerations/SearchType_pb";
import { file_Enumerations_SearchType } from "../Enumerations/SearchType_pb";
import type { TimeTrackingRole } from "../Enumerations/TimeTrackingRole_pb";
import { file_Enumerations_TimeTrackingRole } from "../Enumerations/TimeTrackingRole_pb";
import type { TrackingKindSearchBy } from "../Enumerations/TrackingKindSearchBy_pb";
import { file_Enumerations_TrackingKindSearchBy } from "../Enumerations/TrackingKindSearchBy_pb";
import type { TrackingKindSortBy } from "../Enumerations/TrackingKindSortBy_pb";
import { file_Enumerations_TrackingKindSortBy } from "../Enumerations/TrackingKindSortBy_pb";
import type { TrackingSearchBy } from "../Enumerations/TrackingSearchBy_pb";
import { file_Enumerations_TrackingSearchBy } from "../Enumerations/TrackingSearchBy_pb";
import type { TrackingSortBy } from "../Enumerations/TrackingSortBy_pb";
import { file_Enumerations_TrackingSortBy } from "../Enumerations/TrackingSortBy_pb";
import type { UserWorkingTimeModelSortBy } from "../Enumerations/UserWorkingTimeModelSortBy_pb";
import { file_Enumerations_UserWorkingTimeModelSortBy } from "../Enumerations/UserWorkingTimeModelSortBy_pb";
import type { WorkingTimeModelSearchBy } from "../Enumerations/WorkingTimeModelSearchBy_pb";
import { file_Enumerations_WorkingTimeModelSearchBy } from "../Enumerations/WorkingTimeModelSearchBy_pb";
import type { WorkingTimeModelSortBy } from "../Enumerations/WorkingTimeModelSortBy_pb";
import { file_Enumerations_WorkingTimeModelSortBy } from "../Enumerations/WorkingTimeModelSortBy_pb";
import type { PaginationFilters, UuidDto } from "./Common_pb";
import { file_Messages_Common } from "./Common_pb";
import { file_Options_ValidationFieldOptions } from "../Options/ValidationFieldOptions_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file Messages/Filters.proto.
 */
export const file_Messages_Filters: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_google_protobuf_wrappers, file_Enumerations_BusinessLocationSearchBy, file_Enumerations_BusinessLocationSortBy, file_Enumerations_BusinessSearchBy, file_Enumerations_BusinessSortBy, file_Enumerations_DeletedItemSelection, file_Enumerations_IdentityRoleSearchBy, file_Enumerations_IdentityRoleSortBy, file_Enumerations_IdentityUserSearchBy, file_Enumerations_IdentityUserSortBy, file_Enumerations_ProjectSearchBy, file_Enumerations_ProjectSortBy, file_Enumerations_SearchOperator, file_Enumerations_SearchType, file_Enumerations_TimeTrackingRole, file_Enumerations_TrackingKindSearchBy, file_Enumerations_TrackingKindSortBy, file_Enumerations_TrackingSearchBy, file_Enumerations_TrackingSortBy, file_Enumerations_UserWorkingTimeModelSortBy, file_Enumerations_WorkingTimeModelSearchBy, file_Enumerations_WorkingTimeModelSortBy, file_Messages_Common, file_Options_ValidationFieldOptions]);

/**
 * Used to apply filters when querying businesses.
 *
 * @generated from message time_tracking.messages.filters.BusinessFiltersDto
 */
export type BusinessFiltersDto = Message<"time_tracking.messages.filters.BusinessFiltersDto"> & {
  /**
   * Specifies which set of businesses to return.
   *
   * @generated from field: time_tracking.messages.common.PaginationFilters pagination = 1;
   */
  pagination?: PaginationFilters | undefined;

  /**
   * Specifies whether to include deleted businesses in the result.
   *
   * @generated from field: time_tracking.enumerations.DeletedItemSelection deleted_item_selection = 2;
   */
  deletedItemSelection: DeletedItemSelection;

  /**
   * Specifies the sorting of returned records.
   *
   * @generated from field: repeated time_tracking.messages.filters.BusinessFiltersDto.ColumnSorting sorting = 3;
   */
  sorting: BusinessFiltersDto_ColumnSorting[];

  /**
   * Specifies search texts for columns.
   *
   * @generated from field: repeated time_tracking.messages.filters.BusinessFiltersDto.ColumnSearching searching = 4;
   */
  searching: BusinessFiltersDto_ColumnSearching[];

  /**
   * Determines how the search columns are concatenated.
   *
   * @generated from field: optional time_tracking.enumerations.SearchOperator search_operator = 5;
   */
  searchOperator?: SearchOperator | undefined;

  /**
   * Specifies explicitly which businesses to fetch.
   *
   * @generated from field: repeated time_tracking.messages.common.UuidDto ids = 6;
   */
  ids: UuidDto[];

  /**
   * The tenant id of the businesses to fetch.
   *
   * @generated from field: google.protobuf.StringValue tenant_id = 7;
   */
  tenantId?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.filters.BusinessFiltersDto.
 * Use `create(BusinessFiltersDtoSchema)` to create a new message.
 */
export const BusinessFiltersDtoSchema: GenMessage<BusinessFiltersDto> = /*@__PURE__*/
  messageDesc(file_Messages_Filters, 0);

/**
 * Contains the sorting of a single column.
 *
 * @generated from message time_tracking.messages.filters.BusinessFiltersDto.ColumnSorting
 */
export type BusinessFiltersDto_ColumnSorting = Message<"time_tracking.messages.filters.BusinessFiltersDto.ColumnSorting"> & {
  /**
   * Specifies a column to order by.
   *
   * @generated from field: time_tracking.enumerations.BusinessSortBy sort_by = 1;
   */
  sortBy: BusinessSortBy;

  /**
   * Whether to order the colum values in descending fashion.
   *
   * @generated from field: optional bool descending = 2;
   */
  descending?: boolean | undefined;
};

/**
 * Describes the message time_tracking.messages.filters.BusinessFiltersDto.ColumnSorting.
 * Use `create(BusinessFiltersDto_ColumnSortingSchema)` to create a new message.
 */
export const BusinessFiltersDto_ColumnSortingSchema: GenMessage<BusinessFiltersDto_ColumnSorting> = /*@__PURE__*/
  messageDesc(file_Messages_Filters, 0, 0);

/**
 * Contains the search text for a single column.
 *
 * @generated from message time_tracking.messages.filters.BusinessFiltersDto.ColumnSearching
 */
export type BusinessFiltersDto_ColumnSearching = Message<"time_tracking.messages.filters.BusinessFiltersDto.ColumnSearching"> & {
  /**
   * Specifies a column to search.
   *
   * @generated from field: time_tracking.enumerations.BusinessSearchBy search_by = 1;
   */
  searchBy: BusinessSearchBy;

  /**
   * Specifies how the search text is matched.
   *
   * @generated from field: time_tracking.enumerations.SearchType search_type = 2;
   */
  searchType: SearchType;

  /**
   * The text to search for.
   *
   * @generated from field: string search_text = 3;
   */
  searchText: string;
};

/**
 * Describes the message time_tracking.messages.filters.BusinessFiltersDto.ColumnSearching.
 * Use `create(BusinessFiltersDto_ColumnSearchingSchema)` to create a new message.
 */
export const BusinessFiltersDto_ColumnSearchingSchema: GenMessage<BusinessFiltersDto_ColumnSearching> = /*@__PURE__*/
  messageDesc(file_Messages_Filters, 0, 1);

/**
 * Used to apply filters when querying business locations.
 *
 * @generated from message time_tracking.messages.filters.BusinessLocationFiltersDto
 */
export type BusinessLocationFiltersDto = Message<"time_tracking.messages.filters.BusinessLocationFiltersDto"> & {
  /**
   * Specifies which set of business locations to return.
   *
   * @generated from field: time_tracking.messages.common.PaginationFilters pagination = 1;
   */
  pagination?: PaginationFilters | undefined;

  /**
   * Specifies whether to include deleted business locations in the result.
   *
   * @generated from field: time_tracking.enumerations.DeletedItemSelection deleted_item_selection = 2;
   */
  deletedItemSelection: DeletedItemSelection;

  /**
   * Specifies the sorting of returned records.
   *
   * @generated from field: repeated time_tracking.messages.filters.BusinessLocationFiltersDto.ColumnSorting sorting = 3;
   */
  sorting: BusinessLocationFiltersDto_ColumnSorting[];

  /**
   * Specifies search texts for columns.
   *
   * @generated from field: repeated time_tracking.messages.filters.BusinessLocationFiltersDto.ColumnSearching searching = 4;
   */
  searching: BusinessLocationFiltersDto_ColumnSearching[];

  /**
   * Determines how the search columns are concatenated.
   *
   * @generated from field: optional time_tracking.enumerations.SearchOperator search_operator = 5;
   */
  searchOperator?: SearchOperator | undefined;

  /**
   * Specifies explicitly which business locations to fetch.
   *
   * @generated from field: repeated time_tracking.messages.common.UuidDto ids = 6;
   */
  ids: UuidDto[];

  /**
   * Only consider business locations belonging to one of these business ids.
   *
   * @generated from field: repeated time_tracking.messages.common.UuidDto business_ids = 7;
   */
  businessIds: UuidDto[];

  /**
   * The tenant id of the business locations to fetch.
   *
   * @generated from field: google.protobuf.StringValue tenant_id = 8;
   */
  tenantId?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.filters.BusinessLocationFiltersDto.
 * Use `create(BusinessLocationFiltersDtoSchema)` to create a new message.
 */
export const BusinessLocationFiltersDtoSchema: GenMessage<BusinessLocationFiltersDto> = /*@__PURE__*/
  messageDesc(file_Messages_Filters, 1);

/**
 * Contains the sorting of a single column.
 *
 * @generated from message time_tracking.messages.filters.BusinessLocationFiltersDto.ColumnSorting
 */
export type BusinessLocationFiltersDto_ColumnSorting = Message<"time_tracking.messages.filters.BusinessLocationFiltersDto.ColumnSorting"> & {
  /**
   * Specifies a column to order by.
   *
   * @generated from field: time_tracking.enumerations.BusinessLocationSortBy sort_by = 1;
   */
  sortBy: BusinessLocationSortBy;

  /**
   * Whether to order the colum values in descending fashion.
   *
   * @generated from field: optional bool descending = 2;
   */
  descending?: boolean | undefined;
};

/**
 * Describes the message time_tracking.messages.filters.BusinessLocationFiltersDto.ColumnSorting.
 * Use `create(BusinessLocationFiltersDto_ColumnSortingSchema)` to create a new message.
 */
export const BusinessLocationFiltersDto_ColumnSortingSchema: GenMessage<BusinessLocationFiltersDto_ColumnSorting> = /*@__PURE__*/
  messageDesc(file_Messages_Filters, 1, 0);

/**
 * Contains the search text for a single column.
 *
 * @generated from message time_tracking.messages.filters.BusinessLocationFiltersDto.ColumnSearching
 */
export type BusinessLocationFiltersDto_ColumnSearching = Message<"time_tracking.messages.filters.BusinessLocationFiltersDto.ColumnSearching"> & {
  /**
   * Specifies a column to search.
   *
   * @generated from field: time_tracking.enumerations.BusinessLocationSearchBy search_by = 1;
   */
  searchBy: BusinessLocationSearchBy;

  /**
   * Specifies how the search text is matched.
   *
   * @generated from field: time_tracking.enumerations.SearchType search_type = 2;
   */
  searchType: SearchType;

  /**
   * The text to search for.
   *
   * @generated from field: string search_text = 3;
   */
  searchText: string;
};

/**
 * Describes the message time_tracking.messages.filters.BusinessLocationFiltersDto.ColumnSearching.
 * Use `create(BusinessLocationFiltersDto_ColumnSearchingSchema)` to create a new message.
 */
export const BusinessLocationFiltersDto_ColumnSearchingSchema: GenMessage<BusinessLocationFiltersDto_ColumnSearching> = /*@__PURE__*/
  messageDesc(file_Messages_Filters, 1, 1);

/**
 * Used to apply filters when querying roles.
 *
 * @generated from message time_tracking.messages.filters.IdentityRoleFiltersDto
 */
export type IdentityRoleFiltersDto = Message<"time_tracking.messages.filters.IdentityRoleFiltersDto"> & {
  /**
   * Specifies which set of roles to return.
   *
   * @generated from field: time_tracking.messages.common.PaginationFilters pagination = 1;
   */
  pagination?: PaginationFilters | undefined;

  /**
   * Specifies the sorting of returned records.
   *
   * @generated from field: repeated time_tracking.messages.filters.IdentityRoleFiltersDto.ColumnSorting sorting = 3;
   */
  sorting: IdentityRoleFiltersDto_ColumnSorting[];

  /**
   * Specifies search texts for columns.
   *
   * @generated from field: repeated time_tracking.messages.filters.IdentityRoleFiltersDto.ColumnSearching searching = 4;
   */
  searching: IdentityRoleFiltersDto_ColumnSearching[];

  /**
   * Determines how the search columns are concatenated.
   *
   * @generated from field: optional time_tracking.enumerations.SearchOperator search_operator = 5;
   */
  searchOperator?: SearchOperator | undefined;

  /**
   * Specifies explicitly which roles to fetch.
   *
   * @generated from field: repeated time_tracking.messages.common.UuidDto ids = 6;
   */
  ids: UuidDto[];
};

/**
 * Describes the message time_tracking.messages.filters.IdentityRoleFiltersDto.
 * Use `create(IdentityRoleFiltersDtoSchema)` to create a new message.
 */
export const IdentityRoleFiltersDtoSchema: GenMessage<IdentityRoleFiltersDto> = /*@__PURE__*/
  messageDesc(file_Messages_Filters, 2);

/**
 * Contains the sorting of a single column.
 *
 * @generated from message time_tracking.messages.filters.IdentityRoleFiltersDto.ColumnSorting
 */
export type IdentityRoleFiltersDto_ColumnSorting = Message<"time_tracking.messages.filters.IdentityRoleFiltersDto.ColumnSorting"> & {
  /**
   * Specifies a column to order by.
   *
   * @generated from field: time_tracking.enumerations.IdentityRoleSortBy sort_by = 1;
   */
  sortBy: IdentityRoleSortBy;

  /**
   * Whether to order the colum values in descending fashion.
   *
   * @generated from field: optional bool descending = 2;
   */
  descending?: boolean | undefined;
};

/**
 * Describes the message time_tracking.messages.filters.IdentityRoleFiltersDto.ColumnSorting.
 * Use `create(IdentityRoleFiltersDto_ColumnSortingSchema)` to create a new message.
 */
export const IdentityRoleFiltersDto_ColumnSortingSchema: GenMessage<IdentityRoleFiltersDto_ColumnSorting> = /*@__PURE__*/
  messageDesc(file_Messages_Filters, 2, 0);

/**
 * Contains the search text for a single column.
 *
 * @generated from message time_tracking.messages.filters.IdentityRoleFiltersDto.ColumnSearching
 */
export type IdentityRoleFiltersDto_ColumnSearching = Message<"time_tracking.messages.filters.IdentityRoleFiltersDto.ColumnSearching"> & {
  /**
   * Specifies a column to search.
   *
   * @generated from field: time_tracking.enumerations.IdentityRoleSearchBy search_by = 1;
   */
  searchBy: IdentityRoleSearchBy;

  /**
   * Specifies how the search text is matched.
   *
   * @generated from field: time_tracking.enumerations.SearchType search_type = 2;
   */
  searchType: SearchType;

  /**
   * The text to search for.
   *
   * @generated from field: string search_text = 3;
   */
  searchText: string;
};

/**
 * Describes the message time_tracking.messages.filters.IdentityRoleFiltersDto.ColumnSearching.
 * Use `create(IdentityRoleFiltersDto_ColumnSearchingSchema)` to create a new message.
 */
export const IdentityRoleFiltersDto_ColumnSearchingSchema: GenMessage<IdentityRoleFiltersDto_ColumnSearching> = /*@__PURE__*/
  messageDesc(file_Messages_Filters, 2, 1);

/**
 * Used to apply filters when querying users.
 *
 * @generated from message time_tracking.messages.filters.IdentityUserFiltersDto
 */
export type IdentityUserFiltersDto = Message<"time_tracking.messages.filters.IdentityUserFiltersDto"> & {
  /**
   * Specifies which set of users to return.
   *
   * @generated from field: time_tracking.messages.common.PaginationFilters pagination = 1;
   */
  pagination?: PaginationFilters | undefined;

  /**
   * Specifies whether to include deleted users in the result.
   *
   * @generated from field: time_tracking.enumerations.DeletedItemSelection deleted_item_selection = 2;
   */
  deletedItemSelection: DeletedItemSelection;

  /**
   * Specifies the sorting of returned records.
   *
   * @generated from field: repeated time_tracking.messages.filters.IdentityUserFiltersDto.ColumnSorting sorting = 3;
   */
  sorting: IdentityUserFiltersDto_ColumnSorting[];

  /**
   * Specifies search texts for columns.
   *
   * @generated from field: repeated time_tracking.messages.filters.IdentityUserFiltersDto.ColumnSearching searching = 4;
   */
  searching: IdentityUserFiltersDto_ColumnSearching[];

  /**
   * Determines how the search columns are concatenated.
   *
   * @generated from field: optional time_tracking.enumerations.SearchOperator search_operator = 5;
   */
  searchOperator?: SearchOperator | undefined;

  /**
   * Specifies explicitly which users to fetch.
   *
   * @generated from field: repeated time_tracking.messages.common.UuidDto ids = 6;
   */
  ids: UuidDto[];

  /**
   * Only consider users that have this role assigned to them.
   *
   * @generated from field: time_tracking.enumerations.TimeTrackingRole role = 7;
   */
  role: TimeTrackingRole;

  /**
   * Only consider users associated with the given projects.
   *
   * @generated from field: repeated time_tracking.messages.common.UuidDto project_ids = 8;
   */
  projectIds: UuidDto[];

  /**
   * The tenant id of the users to fetch.
   *
   * @generated from field: google.protobuf.StringValue tenant_id = 9;
   */
  tenantId?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.filters.IdentityUserFiltersDto.
 * Use `create(IdentityUserFiltersDtoSchema)` to create a new message.
 */
export const IdentityUserFiltersDtoSchema: GenMessage<IdentityUserFiltersDto> = /*@__PURE__*/
  messageDesc(file_Messages_Filters, 3);

/**
 * Contains the sorting of a single column.
 *
 * @generated from message time_tracking.messages.filters.IdentityUserFiltersDto.ColumnSorting
 */
export type IdentityUserFiltersDto_ColumnSorting = Message<"time_tracking.messages.filters.IdentityUserFiltersDto.ColumnSorting"> & {
  /**
   * Specifies a column to order by.
   *
   * @generated from field: time_tracking.enumerations.IdentityUserSortBy sort_by = 1;
   */
  sortBy: IdentityUserSortBy;

  /**
   * Whether to order the colum values in descending fashion.
   *
   * @generated from field: optional bool descending = 2;
   */
  descending?: boolean | undefined;
};

/**
 * Describes the message time_tracking.messages.filters.IdentityUserFiltersDto.ColumnSorting.
 * Use `create(IdentityUserFiltersDto_ColumnSortingSchema)` to create a new message.
 */
export const IdentityUserFiltersDto_ColumnSortingSchema: GenMessage<IdentityUserFiltersDto_ColumnSorting> = /*@__PURE__*/
  messageDesc(file_Messages_Filters, 3, 0);

/**
 * Contains the search text for a single column.
 *
 * @generated from message time_tracking.messages.filters.IdentityUserFiltersDto.ColumnSearching
 */
export type IdentityUserFiltersDto_ColumnSearching = Message<"time_tracking.messages.filters.IdentityUserFiltersDto.ColumnSearching"> & {
  /**
   * Specifies a column to search.
   *
   * @generated from field: time_tracking.enumerations.IdentityUserSearchBy search_by = 1;
   */
  searchBy: IdentityUserSearchBy;

  /**
   * Specifies how the search text is matched.
   *
   * @generated from field: time_tracking.enumerations.SearchType search_type = 2;
   */
  searchType: SearchType;

  /**
   * The text to search for.
   *
   * @generated from field: string search_text = 3;
   */
  searchText: string;
};

/**
 * Describes the message time_tracking.messages.filters.IdentityUserFiltersDto.ColumnSearching.
 * Use `create(IdentityUserFiltersDto_ColumnSearchingSchema)` to create a new message.
 */
export const IdentityUserFiltersDto_ColumnSearchingSchema: GenMessage<IdentityUserFiltersDto_ColumnSearching> = /*@__PURE__*/
  messageDesc(file_Messages_Filters, 3, 1);

/**
 * Used to apply filters when querying projects.
 *
 * @generated from message time_tracking.messages.filters.ProjectFiltersDto
 */
export type ProjectFiltersDto = Message<"time_tracking.messages.filters.ProjectFiltersDto"> & {
  /**
   * Specifies which set of projects to return.
   *
   * @generated from field: time_tracking.messages.common.PaginationFilters pagination = 1;
   */
  pagination?: PaginationFilters | undefined;

  /**
   * Specifies whether to include deleted projects in the result.
   *
   * @generated from field: time_tracking.enumerations.DeletedItemSelection deleted_item_selection = 2;
   */
  deletedItemSelection: DeletedItemSelection;

  /**
   * Specifies the sorting of returned records.
   *
   * @generated from field: repeated time_tracking.messages.filters.ProjectFiltersDto.ColumnSorting sorting = 3;
   */
  sorting: ProjectFiltersDto_ColumnSorting[];

  /**
   * Specifies search texts for columns.
   *
   * @generated from field: repeated time_tracking.messages.filters.ProjectFiltersDto.ColumnSearching searching = 4;
   */
  searching: ProjectFiltersDto_ColumnSearching[];

  /**
   * Determines how the search columns are concatenated.
   *
   * @generated from field: optional time_tracking.enumerations.SearchOperator search_operator = 5;
   */
  searchOperator?: SearchOperator | undefined;

  /**
   * Specifies explicitly which projects to fetch.
   *
   * @generated from field: repeated time_tracking.messages.common.UuidDto ids = 6;
   */
  ids: UuidDto[];

  /**
   * Only returns projects that have been assigned to the users with the provided ids.
   *
   * @generated from field: repeated time_tracking.messages.common.UuidDto user_ids = 7;
   */
  userIds: UuidDto[];

  /**
   * The start validity date by which projects should be filtered.
   *
   * @generated from field: google.protobuf.Timestamp date_from = 8;
   */
  dateFrom?: Timestamp | undefined;

  /**
   * The end validity date by which projects should be filtered.
   *
   * @generated from field: google.protobuf.Timestamp date_to = 9;
   */
  dateTo?: Timestamp | undefined;

  /**
   * The tenant id of the projects to fetch.
   *
   * @generated from field: google.protobuf.StringValue tenant_id = 10;
   */
  tenantId?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.filters.ProjectFiltersDto.
 * Use `create(ProjectFiltersDtoSchema)` to create a new message.
 */
export const ProjectFiltersDtoSchema: GenMessage<ProjectFiltersDto> = /*@__PURE__*/
  messageDesc(file_Messages_Filters, 4);

/**
 * Contains the sorting of a single column.
 *
 * @generated from message time_tracking.messages.filters.ProjectFiltersDto.ColumnSorting
 */
export type ProjectFiltersDto_ColumnSorting = Message<"time_tracking.messages.filters.ProjectFiltersDto.ColumnSorting"> & {
  /**
   * Specifies a colum to order by.
   *
   * @generated from field: time_tracking.enumerations.ProjectSortBy sort_by = 1;
   */
  sortBy: ProjectSortBy;

  /**
   * Whether to order the column values in descending fashion.
   *
   * @generated from field: optional bool descending = 2;
   */
  descending?: boolean | undefined;
};

/**
 * Describes the message time_tracking.messages.filters.ProjectFiltersDto.ColumnSorting.
 * Use `create(ProjectFiltersDto_ColumnSortingSchema)` to create a new message.
 */
export const ProjectFiltersDto_ColumnSortingSchema: GenMessage<ProjectFiltersDto_ColumnSorting> = /*@__PURE__*/
  messageDesc(file_Messages_Filters, 4, 0);

/**
 * Contains the search text for a single column.
 *
 * @generated from message time_tracking.messages.filters.ProjectFiltersDto.ColumnSearching
 */
export type ProjectFiltersDto_ColumnSearching = Message<"time_tracking.messages.filters.ProjectFiltersDto.ColumnSearching"> & {
  /**
   * Specifies a column to search.
   *
   * @generated from field: time_tracking.enumerations.ProjectSearchBy search_by = 1;
   */
  searchBy: ProjectSearchBy;

  /**
   * Specifies how the search text is matched.
   *
   * @generated from field: time_tracking.enumerations.SearchType search_type = 2;
   */
  searchType: SearchType;

  /**
   * The text to search for.
   *
   * @generated from field: string search_text = 3;
   */
  searchText: string;
};

/**
 * Describes the message time_tracking.messages.filters.ProjectFiltersDto.ColumnSearching.
 * Use `create(ProjectFiltersDto_ColumnSearchingSchema)` to create a new message.
 */
export const ProjectFiltersDto_ColumnSearchingSchema: GenMessage<ProjectFiltersDto_ColumnSearching> = /*@__PURE__*/
  messageDesc(file_Messages_Filters, 4, 1);

/**
 * Used to apply filters when querying trackings.
 *
 * @generated from message time_tracking.messages.filters.TrackingFiltersDto
 */
export type TrackingFiltersDto = Message<"time_tracking.messages.filters.TrackingFiltersDto"> & {
  /**
   * Specifies which set of trackings to return.
   *
   * @generated from field: time_tracking.messages.common.PaginationFilters pagination = 1;
   */
  pagination?: PaginationFilters | undefined;

  /**
   * Specifies whether to include deleted trackings in the result.
   *
   * @generated from field: time_tracking.enumerations.DeletedItemSelection deleted_item_selection = 2;
   */
  deletedItemSelection: DeletedItemSelection;

  /**
   * Specifies the sorting of returned records.
   *
   * @generated from field: repeated time_tracking.messages.filters.TrackingFiltersDto.ColumnSorting sorting = 3;
   */
  sorting: TrackingFiltersDto_ColumnSorting[];

  /**
   * Specifies search texts for columns.
   *
   * @generated from field: repeated time_tracking.messages.filters.TrackingFiltersDto.ColumnSearching searching = 4;
   */
  searching: TrackingFiltersDto_ColumnSearching[];

  /**
   * Determines how the search columns are concatenated.
   *
   * @generated from field: optional time_tracking.enumerations.SearchOperator search_operator = 5;
   */
  searchOperator?: SearchOperator | undefined;

  /**
   * Specifies explicitly which trackings to fetch.
   *
   * @generated from field: repeated time_tracking.messages.common.UuidDto ids = 6;
   */
  ids: UuidDto[];

  /**
   * The start date and time of the period by which trackings should be filtered.
   *
   * @generated from field: google.protobuf.Timestamp date_time_from = 7;
   */
  dateTimeFrom?: Timestamp | undefined;

  /**
   * The end date and time of the period by which trackings should be filtered.
   *
   * @generated from field: google.protobuf.Timestamp date_time_to = 8;
   */
  dateTimeTo?: Timestamp | undefined;

  /**
   * Only returns trackings belonging to the users with the provided ids.
   *
   * @generated from field: repeated time_tracking.messages.common.UuidDto user_ids = 9;
   */
  userIds: UuidDto[];

  /**
   * Returns only trackings that have an ended_at timestamp or not, depending on the
   * filter value.
   *
   * @generated from field: google.protobuf.BoolValue has_ended = 10;
   */
  hasEnded?: boolean | undefined;

  /**
   * Returns only trackings that have been modified automatically or not, depending on
   * the filter value.
   *
   * @generated from field: google.protobuf.BoolValue most_recently_modified_by_service = 11;
   */
  mostRecentlyModifiedByService?: boolean | undefined;

  /**
   * Only returns trackings associated with the projects with the provided ids.
   *
   * @generated from field: repeated time_tracking.messages.common.UuidDto project_ids = 12;
   */
  projectIds: UuidDto[];

  /**
   * The tenant id of the trackings to fetch.
   *
   * @generated from field: google.protobuf.StringValue tenant_id = 13;
   */
  tenantId?: string | undefined;

  /**
   * Returns only trackings that have no associated project or do have one, depending on
   * the filter value.
   *
   * @generated from field: google.protobuf.BoolValue without_project_association = 14;
   */
  withoutProjectAssociation?: boolean | undefined;
};

/**
 * Describes the message time_tracking.messages.filters.TrackingFiltersDto.
 * Use `create(TrackingFiltersDtoSchema)` to create a new message.
 */
export const TrackingFiltersDtoSchema: GenMessage<TrackingFiltersDto> = /*@__PURE__*/
  messageDesc(file_Messages_Filters, 5);

/**
 * Contains the sorting of a single column.
 *
 * @generated from message time_tracking.messages.filters.TrackingFiltersDto.ColumnSorting
 */
export type TrackingFiltersDto_ColumnSorting = Message<"time_tracking.messages.filters.TrackingFiltersDto.ColumnSorting"> & {
  /**
   * Specifies a colum to order by.
   *
   * @generated from field: time_tracking.enumerations.TrackingSortBy sort_by = 1;
   */
  sortBy: TrackingSortBy;

  /**
   * Whether to order the column values in descending fashion.
   *
   * @generated from field: optional bool descending = 2;
   */
  descending?: boolean | undefined;
};

/**
 * Describes the message time_tracking.messages.filters.TrackingFiltersDto.ColumnSorting.
 * Use `create(TrackingFiltersDto_ColumnSortingSchema)` to create a new message.
 */
export const TrackingFiltersDto_ColumnSortingSchema: GenMessage<TrackingFiltersDto_ColumnSorting> = /*@__PURE__*/
  messageDesc(file_Messages_Filters, 5, 0);

/**
 * Contains the search text for a single column.
 *
 * @generated from message time_tracking.messages.filters.TrackingFiltersDto.ColumnSearching
 */
export type TrackingFiltersDto_ColumnSearching = Message<"time_tracking.messages.filters.TrackingFiltersDto.ColumnSearching"> & {
  /**
   * Specifies a column to search.
   *
   * @generated from field: time_tracking.enumerations.TrackingSearchBy search_by = 1;
   */
  searchBy: TrackingSearchBy;

  /**
   * Specifies how the search text is matched.
   *
   * @generated from field: time_tracking.enumerations.SearchType search_type = 2;
   */
  searchType: SearchType;

  /**
   * The text to search for.
   *
   * @generated from field: string search_text = 3;
   */
  searchText: string;
};

/**
 * Describes the message time_tracking.messages.filters.TrackingFiltersDto.ColumnSearching.
 * Use `create(TrackingFiltersDto_ColumnSearchingSchema)` to create a new message.
 */
export const TrackingFiltersDto_ColumnSearchingSchema: GenMessage<TrackingFiltersDto_ColumnSearching> = /*@__PURE__*/
  messageDesc(file_Messages_Filters, 5, 1);

/**
 * Used to apply filters when querying tracking kinds (billable, etc.).
 *
 * @generated from message time_tracking.messages.filters.TrackingKindFiltersDto
 */
export type TrackingKindFiltersDto = Message<"time_tracking.messages.filters.TrackingKindFiltersDto"> & {
  /**
   * Specifies which set of tracking kinds to return.
   *
   * @generated from field: time_tracking.messages.common.PaginationFilters pagination = 1;
   */
  pagination?: PaginationFilters | undefined;

  /**
   * Specifies whether to include deleted tracking kinds in the result.
   *
   * @generated from field: time_tracking.enumerations.DeletedItemSelection deleted_item_selection = 2;
   */
  deletedItemSelection: DeletedItemSelection;

  /**
   * Specifies the sorting of returned records.
   *
   * @generated from field: repeated time_tracking.messages.filters.TrackingKindFiltersDto.ColumnSorting sorting = 3;
   */
  sorting: TrackingKindFiltersDto_ColumnSorting[];

  /**
   * Specifies search texts for columns.
   *
   * @generated from field: repeated time_tracking.messages.filters.TrackingKindFiltersDto.ColumnSearching searching = 4;
   */
  searching: TrackingKindFiltersDto_ColumnSearching[];

  /**
   * Determines how the search columns are concatenated.
   *
   * @generated from field: optional time_tracking.enumerations.SearchOperator search_operator = 5;
   */
  searchOperator?: SearchOperator | undefined;

  /**
   * Specifies explicitly which tracking kinds to fetch.
   *
   * @generated from field: repeated time_tracking.messages.common.UuidDto ids = 6;
   */
  ids: UuidDto[];

  /**
   * The tenant id of the tracking kinds to fetch.
   *
   * @generated from field: google.protobuf.StringValue tenant_id = 7;
   */
  tenantId?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.filters.TrackingKindFiltersDto.
 * Use `create(TrackingKindFiltersDtoSchema)` to create a new message.
 */
export const TrackingKindFiltersDtoSchema: GenMessage<TrackingKindFiltersDto> = /*@__PURE__*/
  messageDesc(file_Messages_Filters, 6);

/**
 * Contains the sorting of a single column.
 *
 * @generated from message time_tracking.messages.filters.TrackingKindFiltersDto.ColumnSorting
 */
export type TrackingKindFiltersDto_ColumnSorting = Message<"time_tracking.messages.filters.TrackingKindFiltersDto.ColumnSorting"> & {
  /**
   * Specifies a column to order by.
   *
   * @generated from field: time_tracking.enumerations.TrackingKindSortBy sort_by = 1;
   */
  sortBy: TrackingKindSortBy;

  /**
   * Whether to order the colum values in descending fashion.
   *
   * @generated from field: optional bool descending = 2;
   */
  descending?: boolean | undefined;
};

/**
 * Describes the message time_tracking.messages.filters.TrackingKindFiltersDto.ColumnSorting.
 * Use `create(TrackingKindFiltersDto_ColumnSortingSchema)` to create a new message.
 */
export const TrackingKindFiltersDto_ColumnSortingSchema: GenMessage<TrackingKindFiltersDto_ColumnSorting> = /*@__PURE__*/
  messageDesc(file_Messages_Filters, 6, 0);

/**
 * Contains the search text for a single column.
 *
 * @generated from message time_tracking.messages.filters.TrackingKindFiltersDto.ColumnSearching
 */
export type TrackingKindFiltersDto_ColumnSearching = Message<"time_tracking.messages.filters.TrackingKindFiltersDto.ColumnSearching"> & {
  /**
   * Specifies a column to search.
   *
   * @generated from field: time_tracking.enumerations.TrackingKindSearchBy search_by = 1;
   */
  searchBy: TrackingKindSearchBy;

  /**
   * Specifies how the search text is matched.
   *
   * @generated from field: time_tracking.enumerations.SearchType search_type = 2;
   */
  searchType: SearchType;

  /**
   * The text to search for.
   *
   * @generated from field: string search_text = 3;
   */
  searchText: string;
};

/**
 * Describes the message time_tracking.messages.filters.TrackingKindFiltersDto.ColumnSearching.
 * Use `create(TrackingKindFiltersDto_ColumnSearchingSchema)` to create a new message.
 */
export const TrackingKindFiltersDto_ColumnSearchingSchema: GenMessage<TrackingKindFiltersDto_ColumnSearching> = /*@__PURE__*/
  messageDesc(file_Messages_Filters, 6, 1);

/**
 * Used to apply filters when querying user and working time model associations.
 *
 * @generated from message time_tracking.messages.filters.UserWorkingTimeModelFiltersDto
 */
export type UserWorkingTimeModelFiltersDto = Message<"time_tracking.messages.filters.UserWorkingTimeModelFiltersDto"> & {
  /**
   * Specifies which set of user and working time model associations to return.
   *
   * @generated from field: time_tracking.messages.common.PaginationFilters pagination = 1;
   */
  pagination?: PaginationFilters | undefined;

  /**
   * Specifies whether to include deleted user and working time model associations in the result.
   *
   * @generated from field: time_tracking.enumerations.DeletedItemSelection deleted_item_selection = 2;
   */
  deletedItemSelection: DeletedItemSelection;

  /**
   * Specifies the sorting of returned records.
   *
   * @generated from field: repeated time_tracking.messages.filters.UserWorkingTimeModelFiltersDto.ColumnSorting sorting = 3;
   */
  sorting: UserWorkingTimeModelFiltersDto_ColumnSorting[];

  /**
   * Specifies explicitly which user and working time model associations to fetch.
   *
   * @generated from field: repeated time_tracking.messages.common.UuidDto ids = 4;
   */
  ids: UuidDto[];

  /**
   * Specifies explicitly for which users to return working time model associations.
   *
   * @generated from field: repeated time_tracking.messages.common.UuidDto user_ids = 5;
   */
  userIds: UuidDto[];

  /**
   * Specifies explicitly for which working time models to return user associations.
   *
   * @generated from field: repeated time_tracking.messages.common.UuidDto working_time_model_ids = 6;
   */
  workingTimeModelIds: UuidDto[];

  /**
   * The start validity date by which user and working time model associations should be filtered.
   *
   * @generated from field: google.protobuf.Timestamp date_from = 7;
   */
  dateFrom?: Timestamp | undefined;

  /**
   * The end validity date by which user and working time model associations should be filtered.
   *
   * @generated from field: google.protobuf.Timestamp date_to = 8;
   */
  dateTo?: Timestamp | undefined;
};

/**
 * Describes the message time_tracking.messages.filters.UserWorkingTimeModelFiltersDto.
 * Use `create(UserWorkingTimeModelFiltersDtoSchema)` to create a new message.
 */
export const UserWorkingTimeModelFiltersDtoSchema: GenMessage<UserWorkingTimeModelFiltersDto> = /*@__PURE__*/
  messageDesc(file_Messages_Filters, 7);

/**
 * Contains the sorting of a single column.
 *
 * @generated from message time_tracking.messages.filters.UserWorkingTimeModelFiltersDto.ColumnSorting
 */
export type UserWorkingTimeModelFiltersDto_ColumnSorting = Message<"time_tracking.messages.filters.UserWorkingTimeModelFiltersDto.ColumnSorting"> & {
  /**
   * Specifies a column to order by.
   *
   * @generated from field: time_tracking.enumerations.UserWorkingTimeModelSortBy sort_by = 1;
   */
  sortBy: UserWorkingTimeModelSortBy;

  /**
   * Whether to order the colum values in descending fashion.
   *
   * @generated from field: optional bool descending = 2;
   */
  descending?: boolean | undefined;
};

/**
 * Describes the message time_tracking.messages.filters.UserWorkingTimeModelFiltersDto.ColumnSorting.
 * Use `create(UserWorkingTimeModelFiltersDto_ColumnSortingSchema)` to create a new message.
 */
export const UserWorkingTimeModelFiltersDto_ColumnSortingSchema: GenMessage<UserWorkingTimeModelFiltersDto_ColumnSorting> = /*@__PURE__*/
  messageDesc(file_Messages_Filters, 7, 0);

/**
 * Used to apply filters when querying working time models.
 *
 * @generated from message time_tracking.messages.filters.WorkingTimeModelFiltersDto
 */
export type WorkingTimeModelFiltersDto = Message<"time_tracking.messages.filters.WorkingTimeModelFiltersDto"> & {
  /**
   * Specifies which set of working time models to return.
   *
   * @generated from field: time_tracking.messages.common.PaginationFilters pagination = 1;
   */
  pagination?: PaginationFilters | undefined;

  /**
   * Specifies whether to include deleted working time models in the result.
   *
   * @generated from field: time_tracking.enumerations.DeletedItemSelection deleted_item_selection = 2;
   */
  deletedItemSelection: DeletedItemSelection;

  /**
   * Specifies the sorting of returned records.
   *
   * @generated from field: repeated time_tracking.messages.filters.WorkingTimeModelFiltersDto.ColumnSorting sorting = 3;
   */
  sorting: WorkingTimeModelFiltersDto_ColumnSorting[];

  /**
   * Specifies search texts for columns.
   *
   * @generated from field: repeated time_tracking.messages.filters.WorkingTimeModelFiltersDto.ColumnSearching searching = 4;
   */
  searching: WorkingTimeModelFiltersDto_ColumnSearching[];

  /**
   * Determines how the search columns are concatenated.
   *
   * @generated from field: optional time_tracking.enumerations.SearchOperator search_operator = 5;
   */
  searchOperator?: SearchOperator | undefined;

  /**
   * Specifies explicitly which working time models to fetch.
   *
   * @generated from field: repeated time_tracking.messages.common.UuidDto ids = 6;
   */
  ids: UuidDto[];

  /**
   * Only returns working time models that have been assigned to the users with the provided ids.
   *
   * @generated from field: repeated time_tracking.messages.common.UuidDto user_ids = 7;
   */
  userIds: UuidDto[];

  /**
   * Only returns working time models that are assignable from this given date onwards.
   * Working time models that do not have assignability dates set are considered always assignable.
   *
   * @generated from field: google.protobuf.Timestamp assignable_from = 8;
   */
  assignableFrom?: Timestamp | undefined;

  /**
   * Only returns working time models that are assignable until this given date at most.
   * Working time models that do not have assignability dates set are considered always assignable.
   *
   * @generated from field: google.protobuf.Timestamp assignable_until = 9;
   */
  assignableUntil?: Timestamp | undefined;

  /**
   * The tenant id of the working time models to fetch.
   *
   * @generated from field: google.protobuf.StringValue tenant_id = 10;
   */
  tenantId?: string | undefined;
};

/**
 * Describes the message time_tracking.messages.filters.WorkingTimeModelFiltersDto.
 * Use `create(WorkingTimeModelFiltersDtoSchema)` to create a new message.
 */
export const WorkingTimeModelFiltersDtoSchema: GenMessage<WorkingTimeModelFiltersDto> = /*@__PURE__*/
  messageDesc(file_Messages_Filters, 8);

/**
 * Contains the sorting of a single column.
 *
 * @generated from message time_tracking.messages.filters.WorkingTimeModelFiltersDto.ColumnSorting
 */
export type WorkingTimeModelFiltersDto_ColumnSorting = Message<"time_tracking.messages.filters.WorkingTimeModelFiltersDto.ColumnSorting"> & {
  /**
   * Specifies a column to order by.
   *
   * @generated from field: time_tracking.enumerations.WorkingTimeModelSortBy sort_by = 1;
   */
  sortBy: WorkingTimeModelSortBy;

  /**
   * Whether to order the colum values in descending fashion.
   *
   * @generated from field: optional bool descending = 2;
   */
  descending?: boolean | undefined;
};

/**
 * Describes the message time_tracking.messages.filters.WorkingTimeModelFiltersDto.ColumnSorting.
 * Use `create(WorkingTimeModelFiltersDto_ColumnSortingSchema)` to create a new message.
 */
export const WorkingTimeModelFiltersDto_ColumnSortingSchema: GenMessage<WorkingTimeModelFiltersDto_ColumnSorting> = /*@__PURE__*/
  messageDesc(file_Messages_Filters, 8, 0);

/**
 * Contains the search text for a single column.
 *
 * @generated from message time_tracking.messages.filters.WorkingTimeModelFiltersDto.ColumnSearching
 */
export type WorkingTimeModelFiltersDto_ColumnSearching = Message<"time_tracking.messages.filters.WorkingTimeModelFiltersDto.ColumnSearching"> & {
  /**
   * Specifies a column to search.
   *
   * @generated from field: time_tracking.enumerations.WorkingTimeModelSearchBy search_by = 1;
   */
  searchBy: WorkingTimeModelSearchBy;

  /**
   * Specifies how the search text is matched.
   *
   * @generated from field: time_tracking.enumerations.SearchType search_type = 2;
   */
  searchType: SearchType;

  /**
   * The text to search for.
   *
   * @generated from field: string search_text = 3;
   */
  searchText: string;
};

/**
 * Describes the message time_tracking.messages.filters.WorkingTimeModelFiltersDto.ColumnSearching.
 * Use `create(WorkingTimeModelFiltersDto_ColumnSearchingSchema)` to create a new message.
 */
export const WorkingTimeModelFiltersDto_ColumnSearchingSchema: GenMessage<WorkingTimeModelFiltersDto_ColumnSearching> = /*@__PURE__*/
  messageDesc(file_Messages_Filters, 8, 1);

